// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCc4jfBjD5wTPo2IUk9JoiXNycR9kgT348",
  authDomain: "turkeyguide-ab9ed.firebaseapp.com",
  projectId: "turkeyguide-ab9ed",
  storageBucket: "turkeyguide-ab9ed.firebasestorage.app",
  messagingSenderId: "420950378053",
  appId: "1:420950378053:web:f841065410f8c8332a052c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app; 